import { Button } from './ui/button';
import { IMAGES, scrollToSection } from '../lib/constants';

export const WhyHDH = () => {
  return (
    <section id="about" data-testid="why-hdh-section" className="py-0">
      {/* About Split Section */}
      <div className="grid lg:grid-cols-2 min-h-[600px]">
        {/* Left - Image */}
        <div className="relative overflow-hidden">
          <img
            src={IMAGES.gallery[2].src}
            alt="HDH Pool with waterfall feature"
            className="w-full h-full object-cover min-h-[400px]"
          />
        </div>

        {/* Right - Content */}
        <div className="bg-[#0F1D32] flex items-center px-8 md:px-16 lg:px-20 py-16 lg:py-0">
          <div className="max-w-lg">
            <p className="text-amber-400 font-body text-xs font-semibold uppercase tracking-[0.25em] mb-4">
              About HDH Pools
            </p>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-700 text-white leading-tight italic">
              Pool Builder. <br />Southern Utah.
            </h2>
            <p className="mt-6 text-base text-white/60 font-body leading-relaxed">
              HDH Pools & Spas is a locally owned pool construction company serving
              Southern Utah. We combine quality craftsmanship with organized
              operations and clear communication, so you always know exactly
              where your project stands.
            </p>
            <p className="mt-4 text-base text-white/60 font-body leading-relaxed">
              From detailed proposals to real-time progress updates, we built our
              process around the client experience. No guesswork. No gaps in
              communication. Just a well-run project from start to finish.
            </p>
            <div className="flex gap-4 mt-10">
              <Button
                data-testid="about-cta-quote"
                onClick={() => scrollToSection('quote')}
                className="bg-amber-500 hover:bg-amber-600 text-white font-bold text-xs uppercase tracking-wider px-8 py-5 rounded-sm"
              >
                Contact Now
              </Button>
              <Button
                variant="outline"
                data-testid="about-cta-gallery"
                onClick={() => scrollToSection('gallery')}
                className="border-white/20 text-white/70 hover:bg-white/10 hover:text-white font-semibold text-xs uppercase tracking-wider px-8 py-5 rounded-sm"
              >
                See Our Work
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Features Strip */}
      <div className="bg-white py-20">
        <div className="max-w-6xl mx-auto px-6 md:px-12">
          <div className="text-center mb-14">
            <h2 className="font-heading text-3xl sm:text-4xl font-700 text-[#0F1D32] italic">
              Why Homeowners Choose HDH
            </h2>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-10">
            {[
              { title: 'Clear Proposals', desc: 'Detailed scope and estimates. No surprises, no ambiguity.' },
              { title: 'Organized Scheduling', desc: 'Structured timelines with milestones and accountability.' },
              { title: 'Progress Updates', desc: 'Real-time photos, status tracking, and schedule visibility.' },
              { title: 'Direct Communication', desc: 'One point of contact. Responsive and available.' },
              { title: 'Payment Transparency', desc: 'Clear invoicing and payment tracking throughout.' },
              { title: 'Quality Equipment', desc: 'Thoughtful material selection and standards that last.' },
            ].map((item) => (
              <div
                key={item.title}
                data-testid={`feature-card-${item.title.toLowerCase().replace(/\s+/g, '-')}`}
                className="group"
              >
                <div className="w-8 h-[2px] bg-amber-500 mb-4 group-hover:w-12 transition-all duration-300" />
                <h3 className="font-heading text-xl font-700 text-[#0F1D32] italic mb-2">{item.title}</h3>
                <p className="text-sm text-slate-500 font-body leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
